import React from "react";
import { cn } from "../../utils/cn";

export const Divider = ({
  layout = "horizontal",
  align = "left",
  children,
  className,
  ...props
}) => {
  if (layout === "vertical") {
    return (
      <div
        className={cn(
          "inline-flex self-stretch border-l border-urb-border mx-3 min-h-[1rem]",
          className
        )}
        {...props}
      />
    );
  }

  if (!children) {
    return (
      <hr
        className={cn(
          "border-0 border-t border-urb-border my-4 w-full",
          className
        )}
        {...props}
      />
    );
  }

  const alignClasses = {
    left: "justify-start text-left",
    center: "justify-center text-center",
    right: "justify-end text-right",
  };

  return (
    <div
      className={cn(
        "relative flex items-center my-4 w-full",
        alignClasses[align] || alignClasses.left,
        className
      )}
      {...props}
    >
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-urb-border" />
      </div>
      <div className="relative px-3 bg-urb-dark text-xs uppercase tracking-wider text-slate-400 font-medium">
        {children}
      </div>
    </div>
  );
};

export default Divider;
